export default "__VITE_ASSET__D2fgteOf__ 36w, __VITE_ASSET__DMj5uK7Z__ 72w, __VITE_ASSET__BxGTQi_l__ 108w";